<template>
    <div class="row">
      <div id="contentTop" />
      <transition name="el-fade-in-linear" mode="out-in">
      <!-- DEMO OF HOW INTRO BUTTON/CARDS COULD LOOK -->
      <!-- <transition name="el-fade-in-linear" mode="out-in"> -->
      <div :class="cardContainerClass">
        <div class="card" style="margin: 0px 10px">
          <div class="card-header">
            <h3 class="card-title" style="color: #359297;">Welcome to Qualification Check!</h3>
          </div>
          <div class="card-content" style="padding-bottom: 0px">
              <p class="category">Thank you very much for choosing QC as your academic verification partner!</p> 
              <br />
              <p class="category">We would like to invite you to an introductory video call with a member of our Solutions team. This is to ensure we understand what you’re looking to achieve and help you get the most out of our verification services, as well as answer any questions you may have at this early stage.</p>
              <br />
              <p class="category">If you would prefer to reach out to us via email, you can contact us at <span style="color: #359297;">sales@qualificationcheck.com</span>. </p>
              <br />
              <p class="category">You can also have a read through our <a href="https://qualificationcheck.com/organisation-faqs/" target="_blank">FAQs here</a>.</p>
              <br />
              <p class="category">Thank you.</p>
          </div>
              <br />
            <div>
              <div class="button-container card-content">
                <a href="https://calendly.com/ben-greasby" target="_blank">
                    <button class="btn btn-fill btn-wd register-btn" style="margin: auto; display: block; margin-top: auto">
                        <span>Book time slot with an advisor</span>
                    </button>
                </a>
                <router-link to="/dashboard" style="margin: auto">
                    <button class="btn btn-fill btn-wd register-btn" style="margin: auto; display: block; margin-top: auto">
                        <span>Continue to dashboard</span>
                    </button>
                </router-link>
              </div>
          </div>
        </div>
      </div>
      </transition>
    </div>
  </template>
  
  <script>
  export default {
    beforeDestroy() {
      this.closeMenu();
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .card {
    display: flex;
    flex-direction: column;
    width: 75%;
    left: 12.5%;
    text-align: center;
  }
  
  .button-container {
    display: flex;
    margin-top: auto;
    margin-bottom: 15px;
    padding-left: 15%;
  }
  
  @media only screen and (max-width: 770px) {
    .grid-layout {
      display: flex;
      flex-direction: column-reverse;
    }
  
    .card {
      margin-bottom: 15px !important;
    }
  }
  </style>
  